export const DRIVE_HISTORY_LOCATE = 'DRIVE_HISTORY_LOCATE';
export const DRIVE_HISTORY_TRANSPORT_COMPANY = 'DRIVE_HISTORY_TRANSPORT_COMPANY';
export const DRIVE_HISTORY_TRANSPORT_ITEM = 'DRIVE_HISTORY_TRANSPORT_ITEM';
